import React, { useMemo, useState } from "react";
import { useTheme } from "styled-components";
import { FiSend, FiUsers } from "react-icons/fi";
import { Container } from "./styles";
import useEmailMarketingData from "./useEmailMarketingData";
import EmailMarketingLoadingSkeleton from "./EmailMarketingLoadingSkeleton";
import CampaignsTab from "./components/CampaignsTab";
import ContactsTab from "./components/ContactsTab";

const TABS = [
  { id: "campaigns", label: "Campanhas", icon: FiSend, eyebrow: "EMAIL MARKETING · CAMPANHAS", title: "Campanhas de Email" },
  { id: "contacts", label: "Lista de Emails", icon: FiUsers, eyebrow: "EMAIL MARKETING · CONTATOS", title: "Lista de Emails" },
];

export default function EmailMarketing() {
  const theme = useTheme();
  const data = useEmailMarketingData();
  const [activeTab, setActiveTab] = useState("campaigns");

  const currentTab = TABS.find((t) => t.id === activeTab) || TABS[0];

  const updateTagText = useMemo(() => {
    if (activeTab === "campaigns") {
      const n = data.campaigns.length;
      return n > 0 ? `${n} campanha${n !== 1 ? "s" : ""} criada${n !== 1 ? "s" : ""}` : "nenhuma campanha criada";
    }
    const n = data.contacts.length;
    return n > 0 ? `${n} contato${n !== 1 ? "s" : ""} cadastrado${n !== 1 ? "s" : ""}` : "nenhum contato cadastrado";
  }, [activeTab, data.campaigns, data.contacts]);

  if (data.loading) {
    return <EmailMarketingLoadingSkeleton isDark={theme.title === "dark"} />;
  }

  return (
    <Container>
      <div className="header-info">
        <div className="header-details">
          <h3 data-eyebrow={currentTab.eyebrow}>{currentTab.title}</h3>
          <div className="header-meta">
            <span className="status-tag">SISTEMA ATIVO</span>
            <span className="update-tag">{updateTagText}</span>
          </div>
        </div>
      </div>

      <div className="tabs-header">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon /> {tab.label}
            </button>
          );
        })}
      </div>

      {activeTab === "campaigns" && <CampaignsTab data={data} />}
      {activeTab === "contacts" && <ContactsTab data={data} />}
    </Container>
  );
}
